import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import notifier from '../../../_utils/notifier';
import { placeholderAmount } from '../../../config';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { Page } from '../../hoc/Page.jsx';
import { MediaPlaceholder } from '../common/Placeholders.jsx';

import {getNotifications, makeReadNotifications} from '../../actions/user';
import NotificationsItem from './NotificationsItem.jsx';
import ReadAllButton from '../common/Buttons/ReadAllButton.jsx';

class Notifications extends React.Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
    unreadCount: PropTypes.number.isRequired,
  };

  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.props.getNotifications().then(response => { this.setState({isLoading: false}) });
  }

  handleReadAllClick = async () => {
    let notifications = this.props.list.filter(n => !n.read).map(n => n.id);
    await this.props.makeReadNotifications(notifications);
    notifier.success(gettext('Все уведомления прочитаны.'));
  };

  render() {
    let items = [];
    if (this.state.isLoading) {
        for (let i = 0; i < placeholderAmount; i++){
          items.push(<MediaPlaceholder/>);
        }
    } else {
      if (this.props.list.length) {
        items = this.props.list.map(item => <NotificationsItem key={item.id}
                                                               {...item}
                                                               onRead={this.props.makeReadNotifications}/>);
      } else {
        items = <p>{gettext('Список уведомлений пуст')}</p>
      }
    }

    return <div>
      {this.props.unreadCount > 0 && <div className='my-3 text-md-right'>
        <ReadAllButton count={this.props.unreadCount} onReadAll={this.handleReadAllClick}/>
      </div>}
      { items }
    </div>
  }
}

let mapStateToProps = (state) => {
  return {
    list: state.user.notifications,
    unreadCount: state.auth.notifications_count,
  }
};

export default compose(
  connect(mapStateToProps,
    {
      getNotifications, makeReadNotifications
    }),
  LoginRequired,
  Page
)(Notifications)

